import React from 'react';
import classNames from 'classnames/bind';
import { useUncontrolled } from '@mantine/hooks';

import { FilesSearchEntity } from 'files/hooks/useFilesSearch';

import { Checkbox } from 'components/Checkbox/Checkbox';

import styles from './FilesSearchEntitiesInput.module.scss';

const c = classNames.bind(styles);

type FilesSearchEntitiesInputProps = {
  // FIXME Remove once Checkboxes no longer require a id
  id: string;
  value?: FilesSearchEntity[];
  defaultValue?: FilesSearchEntity[];
  onChange?: (value: FilesSearchEntity[]) => void;
  disabled?: boolean;
};

export function FilesSearchEntitiesInput({
  id,
  value,
  defaultValue,
  onChange,
  disabled = false,
}: FilesSearchEntitiesInputProps) {
  const [searchEntities, setSearchEntities] = useUncontrolled<
    FilesSearchEntity[]
  >({
    value: value && Array.from(new Set(value)),
    defaultValue: defaultValue && Array.from(new Set(defaultValue)),
    finalValue: [],
    onChange,
  });

  function handleSearchEntitiesChange(
    event: React.ChangeEvent<HTMLInputElement> & {
      target: { value: FilesSearchEntity };
    }
  ) {
    if (event.target.checked) {
      const newSearchEntities = Array.from(
        new Set([...searchEntities, event.target.value])
      );
      setSearchEntities(newSearchEntities);
      return;
    }

    setSearchEntities(
      [...searchEntities].filter((entity) => entity !== event.target.value)
    );
  }

  return (
    <fieldset className={c('search-entities')}>
      <Checkbox
        id={`${id}-objects`}
        value="objects"
        label="Objects"
        checked={searchEntities.includes('objects')}
        onChange={handleSearchEntitiesChange}
        disabled={disabled}
      />
      <Checkbox
        id={`${id}-events`}
        value="events"
        label="Events"
        checked={searchEntities.includes('events')}
        onChange={handleSearchEntitiesChange}
        disabled={disabled}
      />
      <Checkbox
        id={`${id}-texts`}
        value="texts"
        label="Text"
        checked={searchEntities.includes('texts')}
        onChange={handleSearchEntitiesChange}
        disabled={disabled}
      />
      <Checkbox
        id={`${id}-vectors`}
        value="vectors"
        label="Scenes"
        checked={searchEntities.includes('vectors')}
        onChange={handleSearchEntitiesChange}
        disabled={disabled}
      />
    </fieldset>
  );
}
